import { Component } from '@angular/core';
import { MedrecordIcon } from '../../base/medrecord-icon';

@Component({
  selector: 'medrecord-svg-chevron-up',
  templateUrl: './chevron-up.component.svg',
  styleUrls: ['./chevron-up.component.scss'],
})
export class ChevronUpComponent extends MedrecordIcon {
  viewHeight = 8;
  viewWidth = 13;
}
